export const DASHBOARD_REQUEST = "DASHBOARD_REQUEST";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";

export const FARM_STATISTICS_REQUEST = "FARM_STATISTICS_REQUEST";
export const FARM_STATISTICS_SUCCESS = "FARM_STATISTICS_SUCCESS";
export const FARM_STATISTICS_ERROR = "FARM_STATISTICS_ERROR";